module.exports = __webpack_public_path__ + "img/coupon-notes-arrow-icon.473ca394.svg";